import React from 'react';
import logo from '../Logo04small-retocado-teal.png'; // Importa el logo
import {Grid,Card,Select,MenuItem,CardContent,Typography,Button,Box} from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'; //new para cargar permisos luego de verificar registro en bd
import {useState,useEffect} from 'react';
import axios from 'axios';
import LoginPerfil from "./LoginPerfil" //new
import LoginLogoutBoton from "./LoginLogoutBoton" //new
import palette from '../theme/palette';
import { obtenerIdentidadEquipo, consultarEquipo, verificarEquipoConReto, CONTROL_EQUIPOS_ACTIVO, CONTROL_EQUIPOS_EXIGIDO } from '../security/dispositivo';
import EquipoAutorizadoPanel from './EquipoAutorizadoPanel';


const BienvenidaXpert = ({ onStartClick }) => {
  const back_host = process.env.BACK_HOST || "https://xpertcont-backend-js-production-50e6.up.railway.app";
  const {user, isAuthenticated } = useAuth0();
  const [estudios_select,setEstudioSelect] = useState([]);

  // Control de equipo autorizado: reto/respuesta con clave no exportable.
  // equipoEstado = pendiente | verificando | autorizado | rechazado | sin-control
  // "sin-control" = el backend aun no tiene la tabla de equipos; en ese caso no
  // se bloquea a nadie para no dejar el sistema inaccesible durante la puesta en marcha.
  const [equipoEstado, setEquipoEstado] = useState('pendiente');
  const [equipoInfo, setEquipoInfo] = useState({ motivo: '', huellaCorta: '', etiqueta: '' });

  const [idAnfitrionSeleccionado, setAnfitrionSeleccionado] = useState('');

    //Aqui se leen parametros en caso lleguen
  useEffect( ()=> {
    if (isAuthenticated && user && user.email) {
      verificarEquipoAutorizado(user.email);
    } else if (!isAuthenticated) {
      setEquipoEstado('pendiente');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isAuthenticated, user]);

  // 1ro consulta si el equipo esta registrado, 2do demuestra la posesion de la clave.
  const verificarEquipoAutorizado = async (correo) => {
    // Interruptor maestro apagado: no se verifica nada y no se bloquea el ingreso.
    if (!CONTROL_EQUIPOS_ACTIVO) {
      setEquipoEstado('desactivado');
      cargaEstudiosAnfitrion();
      return;
    }

    setEquipoEstado('verificando');
    try {
      const identidad = await obtenerIdentidadEquipo();
      setEquipoInfo((prev) => ({ ...prev, huellaCorta: identidad.huellaCorta }));

      const consulta = await consultarEquipo(back_host, correo, identidad);
      if (!consulta.disponible) {
        setEquipoInfo({ motivo: consulta.motivo, huellaCorta: identidad.huellaCorta, etiqueta: '' });
        setEquipoEstado('sin-control');
        return;
      }

      if (!consulta.autorizado) {
        setEquipoInfo({ motivo: consulta.motivo, huellaCorta: identidad.huellaCorta, etiqueta: '' });
        setEquipoEstado(CONTROL_EQUIPOS_EXIGIDO ? 'rechazado' : 'sin-control');
        return;
      }

      const verificado = await verificarEquipoConReto(back_host, correo, identidad);
      if (!verificado.autorizado) {
        setEquipoInfo({ motivo: verificado.motivo, huellaCorta: identidad.huellaCorta, etiqueta: '' });
        setEquipoEstado(CONTROL_EQUIPOS_EXIGIDO ? 'rechazado' : 'sin-control');
        return;
      }

      setEquipoInfo({ motivo: '', huellaCorta: identidad.huellaCorta, etiqueta: verificado.etiqueta || '' });
      setEquipoEstado('autorizado');
      cargaEstudiosAnfitrion();
    } catch (error) {
      console.log('No se pudo verificar el equipo:', error);
      setEquipoInfo({ motivo: error.message, huellaCorta: '', etiqueta: '' });
      setEquipoEstado(CONTROL_EQUIPOS_EXIGIDO ? 'rechazado' : 'sin-control');
    }
  };

    const cargarNivelInvitado = async (idAnfitrion) => {
      if (!idAnfitrion || !user?.email) {
        sessionStorage.setItem('supervisor', '0');
        return '0';
      }

      try {
        const anfitrionParam = encodeURIComponent(idAnfitrion);
        const invitadoParam = encodeURIComponent(user.email);
        const response = await axios.get(`${back_host}/usuario/invitado/nivel/${anfitrionParam}/${invitadoParam}`);
        const supervisor = response.data?.supervisor || '0';
        sessionStorage.setItem('supervisor', supervisor);
        return supervisor;
      } catch (error) {
        console.log('Error cargando nivel del invitado:', error);
        sessionStorage.setItem('supervisor', '0');
        return '0';
      }
    };

    const handleChange = async e => {
      const idAnfitrion = e.target.value;
      setAnfitrionSeleccionado(idAnfitrion);
      const estudio = estudios_select.find((item) => item.id_usuario === idAnfitrion);
      if (estudio?.rubro) {
        sessionStorage.setItem('rubro_trabajo', estudio.rubro);
      }
      sessionStorage.setItem('super', estudio?.super || '0');
      await cargarNivelInvitado(idAnfitrion);
    }
  
    const cargaEstudiosAnfitrion = () =>{
      console.log(`${back_host}/usuario/estudios/${user.email}`);
      axios
      .get(`${back_host}/usuario/estudios/${user.email}`)
      .then((response) => {
        //Cargar Arreglo
        setEstudioSelect(response.data);
        // Establece el primer valor del arreglo como valor inicial
        if (response.data.length > 0) {
          setAnfitrionSeleccionado(response.data[0].id_usuario); 
          sessionStorage.setItem('rubro_trabajo', response.data[0].rubro || 'COMERCIAL');
          sessionStorage.setItem('super', response.data[0].super || '0');
          cargarNivelInvitado(response.data[0].id_usuario);
        }
      })
      .catch((error) => {
          console.log(error);
      });
    }

        
    const centeredLogoStyle = {
      display: 'block',
      width: 'min(260px, 76vw)',
      maxHeight: '150px',
      objectFit: 'contain',
      margin: '0 auto',
    };
    
    return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
        background: `radial-gradient(circle at 50% 0%, rgba(42,161,152,0.16), transparent 34%), linear-gradient(180deg, ${palette.bg} 0%, #11181d 100%)`,
      }}
    >

      <div></div>
    <Grid container spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
    >
      <Grid item xs={3}
      >
            <Card
                  sx={{
                    mt: 1,
                    width: 'min(430px, calc(100vw - 32px))',
                    background: `linear-gradient(180deg, ${palette.surfaceAlt} 0%, ${palette.surface} 100%)`,
                    border: `1px solid ${palette.border}`,
                    borderRadius: '8px',
                    boxShadow: '0 22px 70px rgba(0,0,0,0.34)',
                    overflow: 'hidden',
                  }}
            >
                <Box
                  sx={{
                    px: 3,
                    pt: 2.5,
                    pb: 1.5,
                    borderBottom: `1px solid ${palette.borderSoft}`,
                    textAlign: 'center',
                  }}
                >
                <Typography
                  variant='h5'
                  sx={{
                    color: palette.text,
                    fontSize: '21px',
                    fontWeight: 800,
                    lineHeight: 1.18,
                  }}
                >
                    Facturación/Contabilidad Móvil
                </Typography>
                <Typography sx={{ color: palette.muted, fontSize: '12px', mt: 0.6 }}>
                  XpertCont
                </Typography>
                </Box>
                
                <CardContent sx={{ px: 3, py: 2.5 }}>
                      <Grid container spacing={0.5}
                            direction="column"
                            //alignItems="center"
                            justifyContent="center"
                      >

                      <Grid container spacing={0.5}
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                      >
                          <Grid item xs={12}>
                              <LoginPerfil ></LoginPerfil>                
                          </Grid>
                          <Grid item xs={12}>
                              <LoginLogoutBoton ></LoginLogoutBoton>
                           <EquipoAutorizadoPanel
                             estado={equipoEstado}
                             motivo={equipoInfo.motivo}
                             huellaCorta={equipoInfo.huellaCorta}
                             etiqueta={equipoInfo.etiqueta}
                           />
                          </Grid>
                      </Grid>

                      <Box
                        sx={{
                          my: 2,
                          py: 2,
                          px: 1.5,
                          borderRadius: '8px',
                          backgroundColor: palette.accentSoft,
                          border: '1px solid rgba(42,161,152,0.26)',
                        }}
                      >
                        <img
                          src={logo} // Usa la variable de importación para el logo
                          alt="Logo de la aplicación"
                          style={centeredLogoStyle}
                        />
                      </Box>

                      { isAuthenticated && (equipoEstado === 'autorizado' || equipoEstado === 'sin-control' || equipoEstado === 'desactivado'
                        // Con el control apagado el estado inicial 'pendiente' tambien deja pasar: si no, el boton
                        // aparece un instante despues del render en vez de estar siempre.
                        || (!CONTROL_EQUIPOS_ACTIVO && equipoEstado === 'pendiente')) ? 
                      ( <>
                       <Select
                              labelId="estudios_select"
                              size="small"
                              //id={tipo_op}
                              value={idAnfitrionSeleccionado}
                              name="estudios_select"
                              sx={{
                                display:'block',
                                margin:'.1rem 0',
                                color: palette.text,
                                textAlign:'center',
                                backgroundColor: palette.chip,
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: palette.border,
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                  borderColor: palette.accent,
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: palette.accent,
                                },
                                '& .MuiSelect-icon': {
                                  color: palette.muted,
                                },
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    backgroundColor: palette.surface,
                                    color: palette.text,
                                    border: `1px solid ${palette.border}`,
                                    '& .MuiMenuItem-root:hover': {
                                      backgroundColor: palette.accentSoft,
                                    },
                                  },
                                },
                              }}
                              //label="Operacion"
                              onChange={handleChange}
                            >
                              {   
                                  estudios_select.map(elemento => (
                                  <MenuItem key={elemento.id_usuario} value={elemento.id_usuario} >
                                    {elemento.razon_social}
                                  </MenuItem>)) 
                              }
                      </Select>

                      <Button variant='contained' 
                                              color='primary' 
                                              onClick={async () => {
                                                // Devolvemos los props actualizados
                                                const estudio = estudios_select.find((item) => item.id_usuario === idAnfitrionSeleccionado);
                                                const rubro = estudio?.rubro || sessionStorage.getItem('rubro_trabajo') || 'COMERCIAL';
                                                const superAcceso = estudio?.super || sessionStorage.getItem('super') || '0';
                                                const supervisorAcceso = await cargarNivelInvitado(idAnfitrionSeleccionado);
                                                sessionStorage.setItem('rubro_trabajo', rubro);
                                                sessionStorage.setItem('super', superAcceso);
                                                sessionStorage.setItem('supervisor', supervisorAcceso);
                                                onStartClick(idAnfitrionSeleccionado, user.email, rubro, superAcceso, supervisorAcceso);
                                              }}                                              
                                              fullWidth
                                              sx={{
                                                display:'block',
                                                margin:'.8rem 0 0',
                                                py: 1.05,
                                                borderRadius: '8px',
                                                backgroundColor: palette.accent,
                                                color: palette.bg,
                                                fontWeight: 900,
                                                boxShadow: 'none',
                                                '&:hover': {
                                                  backgroundColor: '#7ddbd3',
                                                  boxShadow: '0 10px 24px rgba(42,161,152,0.2)',
                                                },
                                              }}
                                              //sx={{margin:'.5rem 0', height:55}}
                                              >
                      INGRESAR
                      </Button>

                      </>
                      ): (<></>)
                      }

                          <Grid container spacing={0}
                                //direction="column"
                                alignItems="center"
                                justifyContent="left"
                          >
                              <Grid item xs={10}>

                              </Grid>

                              <Grid item xs={1}>

                              </Grid>
                              <Grid item xs={0.5}>

                              </Grid>

                          </Grid>

                      </Grid>

                </CardContent>
            </Card>
      </Grid>

    </Grid>

    </Box>
  );
};

export default BienvenidaXpert;
